import { Z_DRAG_WRAPPER } from '@core/zindexes'

export const DEFAULT_AGENT_THUMBNAIL =
  'https://cdn4.fireworktv.com/medias/2023/10/5/1696532533-qzvlimxw/original/newdefaultsmall.gif'

export const AGENT_FALLBACK_THUMBNAIL =
  'https://cdn4.fireworktv.com/medias/2024/3/12/1710271891-gsfcowkd/400_400/ScreenShot2024-03-12at2.47.24PM.png'

export const MOBILE_BREAKPOINT = 480
export const TABLET_BREAKPOINT = 1024

export const Z_INDEX = {
  MAIN_VIDEO: 1,
  FLOATING_ACTION: 2,
  MODAL: 999,
  BASE_WIDGET: Z_DRAG_WRAPPER, // Base level items - MessagePreviewWrapper & LiveHelperModal
  ONLINE_INDICATOR: 1,
}

export const DEFAULT_MENU_COVER =
  'https://cdn4.fireworktv.com/medias/2024/8/8/1723126414-yebfrnvu/original/one_to_one.png'
